import { getBrand } from "../utils/getBrand";
import { useAvailableRegions } from "./useAvailableRegions";
import { useUserSetting } from "./useUserSetting";

export function usePreferredRegion() {
  const availableRegions = useAvailableRegions();
  const { brandCode } = getBrand();
  const defaultRegion = availableRegions.includes("ca")
    ? "ca"
    : availableRegions[0];

  if (!defaultRegion) {
    throw new Error(
      `no "availableRegions" configured for the brand ${brandCode}`
    );
  }

  return useUserSetting("region", defaultRegion, {
    brand: true,
  });
}
